import { icons } from "./icons";
import { images } from "./images";


export const assets = {
 images,
 icons,
 
}
